module.exports = __webpack_public_path__ + "img/about03.27e0d781.png";